<dc-business-solutions-heading></dc-business-solutions-heading>
<dc-divider-curve [shapeCssText]="'contrast'"></dc-divider-curve>

<dc-business-solutions-integration-icons></dc-business-solutions-integration-icons>
<dc-business-solutions-start-business></dc-business-solutions-start-business>
<dc-slider-features-fluid-cols></dc-slider-features-fluid-cols>

<dc-testimonial-skewed-slider></dc-testimonial-skewed-slider>
<dc-pricing-two-cards></dc-pricing-two-cards>
<dc-divider-curve
  [cssClass]="'mt-12n'"
  [shapeCssText]="'dark'"
></dc-divider-curve>

<dc-business-solutions-pricing-includes></dc-business-solutions-pricing-includes>
<dc-business-solutions-get-theme></dc-business-solutions-get-theme>
<dc-divider-curve [shapeCssText]="'contrast'"></dc-divider-curve>

<dc-footer1></dc-footer1>
